import React from 'react';

import { useIntl } from 'react-intl';

import { identifierTypeTranslationMap } from 'src/features/eventLog/utils/constants';
import { EventData, type EventLog } from 'src/features/eventLog/types';

type CellEventCustomerProps = {
    eventData: EventData;
    event: EventLog;
};

const CellEventCustomer = ({ eventData, event }: CellEventCustomerProps) => {
    const { formatMessage, locale } = useIntl();

    const getEventCustomerCell = React.useCallback((eventData: EventData, event: EventLog) => {
        if ('identifiers' in eventData && 'visitor' in eventData && eventData?.visitor === null) {
            return (
                <div className="flex flex-col">
                    {eventData?.identifiers?.map((identifier, index) => {
                        return (
                            <div className="flex flex-row gap-1 font-medium" key={index}>
                                <div>{identifier.value}</div>
                                {identifier.type && (
                                    <div className="whitespace-nowrap">{`(${formatMessage(identifierTypeTranslationMap[identifier.type])})`}</div>
                                )}
                            </div>
                        );
                    })}
                    <div>{event?.gateway?.translations?.find((gate) => gate.language === locale)?.name ?? ''}</div>
                </div>
            );
        }
        if ('visitor' in eventData) {
            return (
                <div className="flex flex-col">
                    <div className="flex flex-row gap-1 font-medium">
                        <div>{eventData?.visitor?.main_identifier?.value}</div>
                        {eventData?.visitor?.main_identifier?.type && (
                            <div className="whitespace-nowrap">{`(${formatMessage(identifierTypeTranslationMap[eventData?.visitor?.main_identifier?.type])})`}</div>
                        )}
                    </div>
                    <div>{event?.gateway?.translations?.find((gate) => gate.language === locale)?.name ?? ''}</div>
                </div>
            );
        }

        return '-';
    }, []);

    return getEventCustomerCell(eventData, event);
};

export default CellEventCustomer;
